import * as r from "react";
import { forwardRef as o } from "react";
const l = o(function(t, e) {
  return /* @__PURE__ */ r.createElement(
    "svg",
    {
      fill: "none",
      ref: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ r.createElement(
      "path",
      {
        d: "M12 4L14.1244 10.3743H21L15.4374 14.314L17.5618 20.6882L12 16.7485L6.43818 20.6882L8.5626 14.3133L3 10.375H9.87558L12 4Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  l as Star
};
